import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnvService } from 'src/app/core/services';

@Component({
  selector: 'app-notification-overlay',
  templateUrl: './notification-overlay.component.html',
  styleUrls: ['./notification-overlay.component.scss'],
})
export class NotificationOverlayComponent {
  @Input() visible: boolean = false;
  @Input() title!: string;
  @Input() message!: string;
  @Input() additionalDetails?: string;
  @Input() type!: 'error' | 'success';

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter<boolean>();

  ccsConfig = this.envService.ccs;

  constructor(private envService: EnvService) {}

  onConfirm() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.dismiss.emit(true);
  }
}
